import { Button } from '@/components/ui/button'
import { getInvoiceTimingText } from '@/lib/shipment'
import type { ShipmentWithCustomer } from '@/api/types'

const LABEL = 'Faktureras'
const INVOICE_EARLY_LABEL = 'Fakturera före inlämning'
const INVOICE_AT_DISPATCH_LABEL = 'Fakturera vid inlämning'

interface ShipmentInvoiceTimingFieldProps {
  shipment: ShipmentWithCustomer
  isSaving: boolean
  onChange: (invoiceBeforeDispatch: boolean) => void
}

export function ShipmentInvoiceTimingField({ shipment, isSaving, onChange }: ShipmentInvoiceTimingFieldProps): React.ReactElement {
  const isEarly = shipment.invoice_before_dispatch
  const buttonLabel = isEarly ? INVOICE_AT_DISPATCH_LABEL : INVOICE_EARLY_LABEL

  const handleToggle = (): void => {
    onChange(!isEarly)
  }

  return (
    <div className="space-y-2">
      <p className="text-sm text-muted-foreground">{LABEL}</p>
      <div className="flex flex-wrap items-center gap-2">
        <p>{getInvoiceTimingText(shipment)}</p>
        <Button
          type="button"
          variant="outline"
          size="sm"
          className="rounded-none"
          disabled={isSaving}
          onClick={handleToggle}
        >
          {buttonLabel}
        </Button>
      </div>
    </div>
  )
}
